import React from 'react';
import { MulchCalculator } from './MulchCalculator';

export const MulchCalculatorContainer = () => {

  return (
    <MulchCalculator />
  );
};
